const styles = {
  container: {
    position: "absolute",
    width: "auto",
    height: "auto",
    left: 0,
    bottom: 0,
    zIndex: 1,
    transition: "all .3s ease-out",
    pointerEvents: "none",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end"
  },
  map: {
    backgroundClip: "border-box",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "0 100%",
    boxShadow: "0 0 25px rgba(0,0,0,.8)",
    pointerEvents: "all"
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Player/PlayerMinimap/PlayerMinimap.styles.js